import firebase from '@firebase/app';

export const registerContract = (uidProfessor, contract, type, callback) => {
  contract.date_create = firebase.firestore.FieldValue.serverTimestamp();
  return firebase.firestore().collection("professors")
    .doc(`${uidProfessor}/contracts/contract-${type}`)
    .set(contract)
    .then(function (doc) {
      console.log("Document successfully written!");
      callback(doc, true);

    }).catch(function (error) {

      console.error("Error writing document: ", error);
      callback(error, false);
    });
}

export const getContract = (uidProfessor, type, callback) => {

  return firebase.firestore().collection("professors")
    .doc(`${uidProfessor}/contracts/contract-${type}`)
    .get()
    .then(function (doc) {

      if (doc.exists) {
        console.log("Document data:", doc.data());
        callback(doc.data(), true)
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
        callback({ message: "no" }, false)
      }
    }).catch(function (error) {
      callback(error, false)
      console.log("Error getting document:", error);
    });
}






// WEBPACK FOOTER //
// src/dao-firebase/contracts-firebase.js